import React from 'react';

import { useSession } from 'src/services/pagerduty/session';

import CenteredSpinner from 'src/views/components/CenteredSpinner';
import ErrorMessage from 'src/views/components/ErrorMessage';

const OauthCallback = () => {
  const { error, loggedIn, loading } = useSession();

  if (loggedIn) return null;

  const component =
    loading
      ? <CenteredSpinner size="large" />
      : <ErrorMessage error={error || 'Unknown error'} />;

  return (
    <div style={{ padding: 15 }}>
      {component}
    </div>
  );
};

export default OauthCallback;
